import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import CategoryPage from "../pages/category/page";
import ComicDetailPage from "../pages/comic/page";
import ReadPage from "../pages/read/page";
import ArticlePage from "../pages/article/page";
import ArticlesPage from "../pages/articles/page";
import AboutPage from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/category/:slug",
    element: <CategoryPage />,
  },
  {
    path: "/category",
    element: <CategoryPage />,
  },
  {
    path: "/comic/:id",
    element: <ComicDetailPage />,
  },
  {
    path: "/read/:comicId/:chapterId",
    element: <ReadPage />,
  },
  {
    path: "/articles",
    element: <ArticlesPage />,
  },
  {
    path: "/article/:id",
    element: <ArticlePage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
